import React, { useState, useEffect } from "react"

import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import { PersonCircle, GearFill, BarChartFill, ArrowRight, HouseDoorFill, ImageFill } from 'react-bootstrap-icons';
import $ from 'jquery';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const getHeight = () => window.innerHeight
|| document.documentElement.clientHeight
|| document.body.clientHeight;

// const getHeight = () => document.body.scrollHeight;


function useCurrentHeight() {
    // save current window height in the state object
    let [height, setHeight] = useState(getHeight());

    // in this case useEffect will execute only once because
    // it does not have any dependencies.
    useEffect(() => {
        const resizeListener = () => {
            // document.getElementById('root').style.height = getHeight() + 'px';
            // document.getElementById('root').style.overflowY = 'scroll';
            // change height from the state object
            // setHeight(getHeight())
            var bh = $(document.body).height();
            var h = bh-$('.navbar-header').outerHeight();
            // var h = $(document.body).height();
            $('.sidebar').css({height:bh,overflowY:'auto',overflowX:'hidden',scrollbarWidth:'none'})
            $('#bs-sidebar-navbar-collapse-1').css({height:h,overflowY:'auto'}).addClass('scroll-thin')
        };

        // set resize listener
        window.addEventListener('resize', resizeListener);
        resizeListener();
        // clean up function
        return () => {
            // remove resize listener
            window.removeEventListener('resize', resizeListener);
        }
    }, [])

    return height;
}

function sTop()
{
    return window.scrollY || window.scrollTop;
}

function useTop() {
    // save current window height in the state object
    let [top, setTop] = useState(sTop());

    // return height;
    // in this case useEffect will execute only once because
    // it does not have any dependencies.
    useEffect(() => {
            const scrollListener = () => {
                    // setTop(sTop())
                };

                // set scroll listener
                window.addEventListener('scroll', scrollListener);

                // clean up function
                return () => {
                        // remove scroll listener
                        window.removeEventListener('scroll', scrollListener);
                    }
                }, [])
    // console.log( 'useTop', sTop() );
    return sTop();
}


var sideouttid = null;
function sideover(ev)
{
    $('#sidebar').css({marginLeft:0})
    $('.nav-logo').show();
    $('.nav-icon').hide();
}
function sideout(ev)
{
    $('#sidebar').css({marginLeft:-160});
    $('.nav-logo').hide();
    $('.nav-icon').show();
    if( !ev )
    {
        $('#sidebar').addClass('nav-no-events');
        setTimeout( function(){
            $('#sidebar').removeClass('nav-no-events');
        }, 1000 );
    }
}


function MySideNav(prop) {

    var global = window.GlobalVars;
    function navClick(ev)
    {
        sideout();
        // document.getElementById('sidebar').style.marginLeft = '-160px';
        var el = ev.target;
        // console.log( el.tagName )
        while( el && el.tagName != 'LI' ) el = el.parentElement;
        // console.log( el )
        if( !el ) return;
        var page = el.getAttribute('page');
        var pageId = $(el).prop('pageId')
        // console.log( 'CLICK', page, pageId )
        window.goPage(pageId)
        return;
        document.location = document.location.origin+'#'+page;
        window.scrollTo(0,0)
        setTimeout( global.update, 1 );
    }
    var IconTest = BarChartFill;
    var visible = window.GlobalVars.page.match(/(Login|Demo)/) || window.deeplink.length ? 'none' : 'block';


    // console.log( 'COLLAPSE', this.state );
    // console.log( 'RENDER')
    var menu = [];
    global.menu.forEach( m => {
        // if( m.type ) menu.push(m);
        if( m.show )
        {
            menu.push(m);
        }
    })
    // window.$ = $;


    useEffect( function(){
        var sidebar = $('#sidebar');
        sidebar.on('mouseover',sideover);
        sidebar.on('mouseout',sideout);
        var global = window.GlobalVars;
        var menus = window.menuPriv();
        for( var m in menus )
        {
            // console.log( 'MENU', m );
            var p = menus[m];
            var m = $('<LI>').attr('page', p.name).prop('pageId', p.id).on('click', navClick).html(p.nav || p.name).addClass('menu-side').addClass('menu-'+p.id);
            m.append($(p.ficon).addClass('icon-right'));
            // if( p.name == global.page ) m.addClass('active');
            if( p.skip ) m.hide();
            $('#sidebaritems').append(m);
        }

        let supportIcon = $('li[page="support"]');
        if(!window.freshwork_widget) supportIcon.hide();

    },[]);


    return (
        <nav id="sidebar" className="navbar  sidebar"  style={{display:visible,height:useCurrentHeight()}}>
        <div className="container-fluid">
            <div className="navbar-header">
                {/* <img className="nav-logo" src="imgs/sidebar-logo.png"/> */}
                {/* <img className="nav-icon" src="imgs/sidebar-icon.png"/> 15/12 mani*/}
                {/* <img className="nav-icon" src="imgs/logo_new.png"/> 10/1 MANI*/}
                {/* <img className="nav-icon" src="imgs/sidebar-icon.png"/>  */}
                {/* <img className="nav-icon" src="imgs/new/Logo_newT.png"/>  */}
                {/* <img className="nav-icon" src="imgs/new/t2 copy.png"/> 11/4 */}
                {/* <img className="nav-icon" src="imgs/new/t8.png"/>  */}
                {/* <img className="nav-icon" src="imgs/new/f4.png"/>  */}
                <img className="nav-icon" src="imgs/new/f10.png"/> 
                
            </div>
            <div className="navbar" id="bs-sidebar-navbar">
                <ul id="sidebaritems" className="nav navbar-nav">

                </ul>
            </div>
        </div>
        </nav>
    );



}

export default MySideNav;
